import React from 'react'
import Hero from './hero';
import HomeService from './homeservice';
import USPSection from './usp';
import ContactUs from './contactus';
import BrandMarquee from './logobar';

export const Home = () => {
  return (
    <section className='home'>
      <Hero />
      <HomeService />
      <USPSection />
      <BrandMarquee />
      <ContactUs />
       
    </section>
  )
}
export default Home;
